import { Box, Flex, Icon, Stack } from '@storyofams/react-ui'
import { AnimatePresence, motion } from 'framer-motion'
import { defineMessages, FormattedMessage, useIntl } from 'react-intl'
import { Button, Heading } from '~components'
import { Drawer } from '~components/common/Drawer'
import { Cross } from '~components/common/Icons'

const messages = defineMessages({
  title: 'Filters',
  resetTitle: 'Reset filters',
  preparation: 'Preparation',
  without: 'Made without',
  spiciness: 'Spiciness',
  lifestyle: 'Lifestyle',
  Kitchen: 'Kitchen is inspired by',
  type: 'Meals',
  showingFilters: 'Save filters ({amount})',
})

export const Filters = ({
  isShowingFilters,
  setIsShowingFilters,
  parsedQuery,
  handleFilterChange,
  handleReset,
  products,
  filtersMapping,
}) => {
  const intl = useIntl()
  const categories = {
    type: 'Meals',
    preparation: 'Bereidingswijze',
    without: 'Gemaakt zonder',
    spiciness: 'Pittigheid',
    lifestyle: 'Lifestyle',
    Kitchen: 'Kitchen is inspired by',
  }

  const filtersByCategory = Object.keys(categories)?.map(key => ({
    key,
    title: intl.formatMessage(messages[key]),
    filters: filtersMapping
      ?.filter(f => f.split('_')[0] === key)
      ?.map(f => f.split('_')[1]),
  }))

  const toggleFilters = (key, tag) =>
    parsedQuery?.[key]?.includes(tag)
      ? handleFilterChange({
          ...parsedQuery,
          [key]: parsedQuery?.[key]?.filter(f => f !== tag),
        })
      : handleFilterChange({
          ...parsedQuery,
          [key]: [...(parsedQuery?.[key] || []), tag],
        })

  return (
    <>
      <Drawer
        isOpen={isShowingFilters}
        close={() => setIsShowingFilters(false)}
        title={intl.formatMessage(messages.title)}
        flexDirection="column"
        withOverflowHidden
        from={'left'}
        // customBackgroundOverlay={'transparent'}
        CustomBottomElement={() => (
          <Box bg={'#F1EBE5'} px={3} pt={3} pb={'19px'}>
            <Button
              onClick={() => setIsShowingFilters(false)}
              width="100%"
              variant={'button_type_1'}
            >
              <FormattedMessage
                defaultMessage={'Save filters ({amount})'}
                values={{ amount: products?.edges?.length }}
              />
            </Button>
            <Button
              variant="link_filter"
              onClick={handleReset}
              width="100%"
              disabled={!Object.keys(parsedQuery)?.length}
            >
              {intl.formatMessage(messages.resetTitle)}
            </Button>
          </Box>
        )}
      >
        <Stack
          space={4}
          flexDirection="column"
          pb={4}
          flex={1}
          overflowY="auto"
        >
          {filtersByCategory.map(({ key, title, filters }) => (
            <Box key={key} borderBottom={'1px solid #69A8A2'} pb={2}>
              <Heading variant="h5" as="h5" mb={'20px'}>
                {title}
              </Heading>

              <Flex flexDirection={'column'} alignItems={'flex-start'}>
                {filters?.map((tag, i) => (
                  <Button
                    width={'100%'}
                    justifyContent={'flex-start'}
                    key={tag}
                    variant={
                      parsedQuery?.[key]?.includes(tag)
                        ? 'link_nav_selected'
                        : 'link_nav'
                    }
                    onClick={() => toggleFilters(key, tag)}
                  >
                    {tag}
                  </Button>
                ))}
              </Flex>
            </Box>
          ))}
        </Stack>
      </Drawer>

      {/* <AnimatePresence>
        {isShowingDesktopFilters && (
          <motion.div
            initial={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ ease: 'easeInOut', duration: 0.1 }}
          >
            <Flex maxWidth={1200} mx="auto">
              {filtersByCategory.map(({ key, title, filters }, i) => (
                <Box key={key} minWidth={[180]} ml={!!i && 8}>
                  <Heading variant="h5" as="h5" mb={2}>
                    {title}
                  </Heading>

                  <Flex flexWrap="wrap" mt="-8px">
                    {filters?.map((tag) => (
                      <Button
                        key={tag}
                        px={2}
                        py={1.5}
                        mr={2}
                        mt={1}
                        variant={
                          parsedQuery?.[key]?.includes(tag) ? 'primary' : 'outline'
                        }
                        onClick={() => toggleFilters(key, tag)}
                      >
                        {tag}
                      </Button>
                    ))}
                  </Flex>
                </Box>
              ))}
            </Flex>
          </motion.div>
        )}
      </AnimatePresence> */}
    </>
  )
}
